// U-44: 401 로 자동 로그아웃된 뒤 로그인 화면이 "만료" 안내를 한 번 보여주기 위한 1회용 표식.
// Logout 이 sessionStorage 를 비우고, 이동 직후 로그인 화면이 바로 마운트되므로 모듈 변수로 보관한다.
let pending = false;

export const markSessionExpired = () => {
    pending = true;
};

// 읽으면서 지운다(한 번만 노출).
export const consumeSessionExpired = () => {
    const was = pending;
    pending = false;
    return was;
};
